module.exports = __webpack_public_path__ + "img/media_10.3728396d.jpg";